import { render } from "./User.form.vue?vue&type=template&id=e31f63ca&scoped=true"
import script from "./User.form.vue?vue&type=script&lang=js"
export * from "./User.form.vue?vue&type=script&lang=js"

import "./User.form.vue?vue&type=style&index=0&id=e31f63ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31f63ca"]])

export default __exports__